export default `<!-- SparkLayer product quick buy script-->
<spark-product-card mode-quick-buy parent-id="{{id}}"></spark-product-card>
<!-- Hide any element by adding data-spark="b2c-only" to it, e.g. -->
<div data-spark="b2c-only">
    <!-- This would hide anything inside-->
</div>
`;
